import React, { useEffect, useState } from "react";
import axios from "axios";
import InputOption from "../../../component/InputOption/InputOption"

const OutstandingComponent = ({ onSubtotalUpdated, onDataUpdated, idReceiver }) => {
    const [optionOutstanding, setOptionOutstanding] = useState([]);

    const [rows, setRows] = useState([]);

    const [error, setError] = useState(null);

    const handleChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const calculateRowTotal = (row) => {
        return row.amount;
    };

    const calculateRowOutstanding = (row) => {
        return row.outstanding_amount - row.amount;
    };

    const calculateSubtotal = () => {
        return rows.reduce((total, row) => total + calculateRowTotal(row), 0);
    };

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_OUTSTANDING_SALE = `api/erpppsu/expenses/outstanding?receiver=${idReceiver}`;

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            // setLoading(false);
        }
    };

    useEffect(() => {
        onDataUpdated(rows);        
        onSubtotalUpdated(calculateSubtotal());
    }, [rows])

    useEffect(() => {
        const transformedData = optionOutstanding.map((item) => ({
            id: item.id,
            no_transaction: item.no_transaction,
            due_date: item.due_date,
            total_amount: parseFloat(item.amount) || 0,
            outstanding_amount: parseFloat(item.outstanding_amount) || 0,
            outstanding: 0,
            amount: 0,
        }));
        setRows(transformedData);
    }, [optionOutstanding])

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_OUTSTANDING_SALE}`).then((data) => {
            setOptionOutstanding(data);
        });
    }, [])

    return (
        <div className="p-4 relative">
            <div className="max-w-lg md:min-w-[640px] md:max-w-screen-lg overflow-x-auto">
                <table className="w-full border-collapse border border-gray-200">
                    <thead className="bg-gray-100">

                        <tr>
                            <th className="min-w-40 p-2 border border-gray-200">No. Transaksi</th>
                            <th className="min-w-40 p-2 border border-gray-200">Tanggal Jatuh Tempo</th>
                            <th className="min-w-25 p-2 border border-gray-200">Total</th>
                            <th className="min-w-40 p-2 border border-gray-200">Sisa Tagihan</th>
                            <th className="min-w-40 p-2 border border-gray-200">Jumlah</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td className="p-2 border border-gray-200">
                                    {row.no_transaction}
                                </td>
                                <td className="p-2 border border-gray-200">
                                    {row.due_date}
                                </td>
                                <td className="p-2 border border-gray-200">
                                    Rp {row.total_amount.toLocaleString("id-ID", {
                                        minimumFractionDigits: 2,
                                    })}
                                </td>
                                <td className="p-2 border border-gray-200">
                                    Rp {calculateRowOutstanding(row).toLocaleString("id-ID", {
                                        minimumFractionDigits: 2,
                                    })}
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <input
                                        type="number"
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.amount}
                                        onChange={(e) => {
                                            handleChange(index, "outstanding", parseInt(row.outstanding_amount) - parseInt(e.target.value))
                                            handleChange(index, "amount", parseInt(e.target.value))
                                        }}
                                    />
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default OutstandingComponent;
